import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Objective, Activity, Project, User, UserType, Icons } from 'toolbandi-ui-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService, CrudService, MessageService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityEditComponent } from '../activity-edit/activity-edit.component';

@Component({
	selector: 'app-activity-view',
	templateUrl: './activity-view.component.html',
	styleUrls: ['./activity-view.component.scss']
})
export class ActivityViewComponent implements OnInit, OnDestroy {

	objective: Objective;
	project: Project;
	loading: boolean = false;
	activity: Activity;
	breadcrumb: any;


	usercompanyid: number;

	error: boolean;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private activityService: CrudService<Activity>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private objectiveService: CrudService<Objective>,
		private projectService: CrudService<Project>,
		private router: Router
	) {
		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				const user: User = data as User;
				this.usercompanyid = (user.utype === UserType.company) ? user.companyid : undefined;
			}
		});
	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
		});
	}

	load(id: number): void {
		this.loading = true;
		this.activityService.getEntity(Activity, 'activity', id).subscribe(activity => {
			this.activity = activity;
			if (this.activity) {
				this.error = false;
				this.objectiveService.getEntity(Objective, 'objective', this.activity.objectiveid).subscribe(objective => {
					this.objective = objective;
					if (this.project) {
						this.loading = false;
						this.setBreadcrumb();
					}
				});

				this.projectService.getEntity(Project, 'project', this.activity.projectid).subscribe(project => {
					this.project = project;
					if (this.objective) {
						this.loading = false;
						this.setBreadcrumb();
					}
				});
			} else {
				this.error = true;
				this.loading = false;
			}


		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.activity'));
			this.activity = undefined;
			this.loading = false;
			this.error = true;
		});

	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [{ title: 'labels.companies', url: '/company' },
		{ title: this.project.company.name, url: '/company/view/' + this.project.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		{ title: this.project.name, url: '/company/project/view/' + this.project.id, icon: Icons.PROJECT, icontooltip: 'labels.project' },
		];
		this.breadcrumb.title = { title: this.objective.name + ' - ' + this.activity.name, param: '', icon: Icons.ACTIVITY, icontooltip: 'labels.activity' };
	}

}
